import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import IconBtn from "../CourseForm/IconButton";
import { IoIosAddCircleOutline } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import NestedView from "./NestedView";
import { IoIosArrowForward } from "react-icons/io";
import {
  setCourse,
  setEditCourse,
  setStep,
} from "../../../../../slices/courseSlice";
import toast from "react-hot-toast";
import { updateSection } from "../../../../../services/operations/courseDetailsAPI";
import { createSection } from "../../../../../services/operations/courseDetailsAPI";

function CourseBuilderForm(props) {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  //   Edit section state variable
  const [editSectionName, setEditSectionName] = useState(null);
  const { step, course } = useSelector((state) => state.course);
  const { token } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();

  function cancelEdit() {
    /*
       when we click on cancel edit which will pop when
       we click on edit course button this function
       is to mark setEditSection as null and setValue for sectionName as null because if the
       edit is cancelled its value should now be updated 
    */
    setEditSectionName(null);
    setValue("sectionName", null);
  }

  useEffect(() => {
    console.log("Current Step", step);
  });

  function goToNext() {
    /*
        goToNext is called when we have created the course section and subsections
        it then validate it with and is all the validation
        are completed then we can set the value of form to 3
    */
    // console.log("Current Step", step);
    if (course.courseContent.length === 0) {
      toast.error("Please add atleast on section");
      return;
    }
    if (
      course.courseContent.some((section) => section.subSection.length === 0)
      ) {
        toast.error("Please add atleast one lecture in each section");
        return ;
      }
      // if course content length is not 0 and subsection is not empty then
      // console.log("Current Step", step);
      
      toast.success("Step 2 is completed");
      dispatch(setStep(3));
  }

  function goBack() {
    /*
        goBack function is used to navigate back to previous form but when we are going back to the form it means that
        we must have filled it once then only we came to step 2
        so we will mark setEditCourse as true which means
        we are going to edit the course details
    */
    dispatch(setStep(1));
    dispatch(setEditCourse(true));
  }

  async function onSubmit(data) {
    /*
        onSubmit will be called when we submit the form

    */
    setLoading(true);
    let result;

    if (editSectionName) {
      /*
            Editing section
        */
      result = await updateSection(
        {
          sectionName: data.sectionName,
          sectionId: editSectionName,
          courseId: course._id,
        },
        token
      );
    } else {
      result = await createSection(
        {
          sectionName: data.sectionName,
          courseID: course._id,
        },
        token
      );
    }
    // update values
    if (result) {
      dispatch(setCourse(result));
      setEditSectionName(null);
      setValue("sectionName", "");
    }

    // loading
    setLoading(false);
  }

  function handleChangeEditSectionName(sectionID, sectionName) {
    // section id is defined as sectionID in schema

    if (editSectionName === sectionID) {
      cancelEdit();
      return;
    }
    setEditSectionName(sectionID);
    setValue("sectionName", sectionName);
  }

  return (
    <div className="text-richblack-25">
      <p>Course Builder</p>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <label htmlFor="sectionName">
            Section name <sup className="text-pink-200">*</sup>
          </label>
          <input
            type="text"
            name=""
            id="sectionName"
            placeholder="Add section name"
            {...register("sectionName", { required: true })}
            className="w-full bg-richblack-700 text-richblack-50 py-2 px-4 rounded-md border-b border-richblack-500"
          />
          {errors.sectionName && <span>Section name is required</span>}
        </div>

        {/* Create section input */}
        <div className="mt-10 flex gap-x-5">
          <IconBtn
            type="Submit"
            text={editSectionName ? "Edit section name" : "Create section"}
            outline={true}
            customClasses={"text-white"}>
            <IoIosAddCircleOutline className="text-yellow-50 font-semibold text-xl" />
          </IconBtn>
          {editSectionName && (
            <button
              type="button"
              onClick={cancelEdit}
              className="text-richblack-100 underline">
              Cancel Edit
            </button>
          )}
        </div>
      </form>
      {/* Nested view component */}

      {/* course content is an array in course schema */}
      {course.courseContent.length > 0 && (
        <NestedView handleChangeEditSectionName={handleChangeEditSectionName} />
      )}
      {/* <NestedView handleChangeEditSectionName={handleChangeEditSectionName}/> */}
      <div className="flex justify-end gap-x-3 mt-10">
        <button
          onClick={goBack}
          className="text-richblack-50 bg-richblack-800 rounded-md py-2 px-4 flex items-end">
          Back
        </button>
        <button
          onClick={goToNext}
          className="text-richblack-900 bg-yellow-25 rounded-md py-2 px-4 flex items-end">
          Next
          <IoIosArrowForward className="text-richblack-900" />
        </button>
      </div>
    </div>
  );
}

export default CourseBuilderForm;